import React from 'react';
import { batch, useDispatch, useSelector } from 'react-redux';
import { sendGAEvent } from '@noths/polaris-client-google-analytics';

import type { ReduxApplicationState } from 'src/redux/combinedReducer';
import { requestProducts } from 'src/redux/products/thunks/requestProducts';
import { updatePageURLWithQuery } from 'src/redux/products/thunks/updatePageURLWithQuery';
import { TriggerName } from 'src/redux/products/types';
import {
  selectActiveFacets,
  selectTotalActiveOptions,
} from 'src/redux/productsQuery/selectors/selectors';
import { actions } from 'src/redux/productsQuery/slice';
import type { AppThunkDispatch } from 'src/redux/store';
import { scrollToTopOfProductsList } from 'src/utils/scrollToTopOfProductsList';
import type { ChangedFacetDetails } from '../ListingsControlsOptions/types';
import { ActiveFacets } from './ActiveFacets';

export const ActiveFacetsContainer = () => {
  const state = useSelector((state: ReduxApplicationState) => state);
  const dispatch = useDispatch<AppThunkDispatch>();
  const activeFacets = selectActiveFacets(state);
  const totalActiveFacets = activeFacets.length;
  const totalActiveFacetOptions = selectTotalActiveOptions(state);

  const resetFacetOption = (changedFacet: ChangedFacetDetails) => {
    batch(() => {
      dispatch(actions.changeFacetOption(changedFacet));
      dispatch(requestProducts({ triggerName: TriggerName.CHANGE_FACETS }));
      dispatch(updatePageURLWithQuery());
    });

    scrollToTopOfProductsList();

    const changedOption = changedFacet.options[0];

    sendGAEvent({
      event: 'custom_event',
      event_category: 'Filters',
      event_action: `reset filter ${changedFacet.title}`,
      event_label: changedOption.title,
    });
  };

  const resetAllFacets = () => {
    batch(() => {
      dispatch(actions.resetFacets());
      dispatch(requestProducts({ triggerName: TriggerName.CHANGE_FACETS }));
      dispatch(updatePageURLWithQuery());
    });

    scrollToTopOfProductsList();

    sendGAEvent({
      event: 'custom_event',
      event_category: 'Filters',
      event_action: 'reset all filters',
      event_label: `number of categories: ${totalActiveFacets}|number of filters: ${totalActiveFacetOptions}`,
    });
  };

  return (
    <ActiveFacets
      activeFacets={activeFacets}
      onResetFacet={resetFacetOption}
      onResetFacets={resetAllFacets}
    />
  );
};
